export function isJwtExpired(token, now = Date.now()) {
  if (!token || typeof token !== "string") return true;

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return true;

    const payloadBase64 = parts[1]
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(Math.ceil(parts[1].length / 4) * 4, "=");
    const payload = JSON.parse(window.atob(payloadBase64));
    const expiresAt = Number(payload.exp) * 1000;

    return !Number.isFinite(expiresAt) || expiresAt <= now;
  } catch (error) {
    return true;
  }
}

export function clearAuthStorage() {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("token");
}
